import axios from 'axios';
import { Tag } from '../interfaces/api/tag';

export interface TagsParams {
	name?: string;
	provider?: string;
	unit?: string;
	description?: string;
	modality?: number;
	device?: number;
	energy_carrier_type?: string;
	system_type?: string;
	meter_level?: number;
	active?: boolean;
	type?: string;
}

export interface TagFilterParams {
	modality?: string;
	modalityModalityType?: string;
	device?: string;
	deviceController?: string;
	deviceOrganization?: string;
	deviceBuilding?: string;
	deviceFloor?: string;
	deviceRoom?: string;
	deviceDeviceType?: string;
	search?: string;
	fields?: string;
}

function queryBuilderTag(params: TagFilterParams): URLSearchParams {
	const queryParams = new URLSearchParams();
	if (params.modality) {
		queryParams.append('modality', params.modality);
	}
	if (params.modalityModalityType) {
		queryParams.append('modality__modalityType', params.modalityModalityType);
	}
	if (params.device) {
		queryParams.append('device', params.device);
	}
	if (params.deviceController) {
		queryParams.append('device__controller', params.deviceController);
	}
	if (params.deviceOrganization) {
		queryParams.append('device__organization', params.deviceOrganization);
	}
	if (params.deviceBuilding) {
		queryParams.append('device__building', params.deviceBuilding);
	}
	if (params.deviceFloor) {
		queryParams.append('device__floor', params.deviceFloor);
	}
	if (params.deviceRoom) {
		queryParams.append('device__room', params.deviceRoom);
	}
	if (params.deviceDeviceType) {
		queryParams.append('device__device_type', params.deviceDeviceType);
	}
	if (params.search) {
		queryParams.append('search', params.search);
	}
	if (params.fields) {
		queryParams.append('fields', params.fields);
	}
	return queryParams;
}

export async function getTags(params: TagFilterParams = {}): Promise<Tag[]> {
	try {
		const queryParams = queryBuilderTag(params);
		const response = await axios.get<Tag[]>('api/tags/', {
			params: queryParams,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getTag(id: number, params: TagFilterParams = {}): Promise<Tag> {
	try {
		const queryParams = queryBuilderTag(params);
		const response = await axios.get<Tag>(`api/tags/${id}/`, {
			params: queryParams,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function patchTag(id: number, params: TagsParams): Promise<Tag> {
	try {
		const response = await axios.patch<Tag>(`api/tags/${id}/`, params);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}
